<template>
    <div class="wrap1200">
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
      <div class="container">
        <h1>唐山瑞喜数字科技有限公司</h1>
        <h2>瑞喜数字欢迎您加入！</h2>
        
        <a href="https://www.goucaiwang888.com">
          <img src="../assets/banner.jpg" alt="企业理念">
        </a>
        
        <p>唐山瑞喜数字科技有限公司秉持着弘扬中国彩票发行宗旨、服务广大彩民的初心与使命，成立了专注于彩票领域的
          <a href="https://www.goucaiwang888.com" target="_blank" class="highlight">购彩网</a>，
          作为一个数据平台，购彩网深耕于中国福利彩票和中国体育彩票领域，
          致力于深入挖掘历史开奖数据，并借助<span class="highlight">AI技术</span>，
          对海量的开奖数据进行汇总、计算与分析。</p>
  
        <img src="../assets/img1.jpg" alt="数据可视化">
  
        <p>通过精心绘制各种彩票开奖数据走势图形，辅助探索、挖掘往期开奖数据中的规律与趋势，
          从而为彩民朋友们提供更加舒适的使用体验。通过对"分析本期"和"分析下期"功能的使用，
          辅助彩民朋友们进行<span class="highlight">智能号码筛选</span>！</p>
  
        <div class="image-group">
          <img src="../assets/img2.jpg" alt="分析界面">
          <img src="../assets/img3.jpg" alt="会员特权">
        </div>
  
        <p class="highlight" style="font-size: 20px; text-align: center;">
          现在加入，成为会员还能享受30天免费试用！快来试试吧！
        </p>
        
        <a href="https://www.goucaiwang888.com">
          <img src="../assets/img4.jpg" alt="社会责任">
        </a>
      
        <p><a href="https://www.goucaiwang888.com" target="_blank" class="highlight">购彩网</a>
          始终坚守着支持国家彩票发展、传递爱心的信念，期望通过自身的努力，让福报多多，
          润泽每一位彩民的心田，为社会公益事业贡献自己的一份力量。</p>
  
        <a href="https://www.goucaiwang888.com" target="_blank" class="cta-button">
          立即访问购彩网
        </a>
      </div>
  
      <div class="footer">
        <p>© 2023 唐山瑞喜数字科技有限公司 版权所有</p>
      </div>
    </div>
  </template>
  
  <script>
  import Breadcrumb from '../components/Breadcrumb.vue';
  export default {
    name: 'CompanyIntroduction',
    components: {
        Breadcrumb
    },
    // You can add component data, methods, lifecycle hooks here if needed
  }
  </script>
  
  <style scoped>
  body {
    font-family: "Microsoft YaHei", Arial, sans-serif;
    line-height: 1.6;
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
  }
  .wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
  .container {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  
  h1 {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 30px;
  }
  
  h2 {
    color: #2c3e50;
  }
  
  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
    border-radius: 8px;
  }
  
  .highlight {
    color: #e74c3c;
    font-weight: bold;
  }
  
  .cta-button {
    display: block;
    width: 200px;
    margin: 30px auto;
    padding: 12px;
    background-color: #3498db;
    color: white;
    text-align: center;
    text-decoration: none;
    border-radius: 25px;
    font-size: 18px;
    transition: background-color 0.3s;
  }
  
  .cta-button:hover {
    background-color: #2980b9;
  }
  
  .footer {
    text-align: center;
    margin-top: 40px;
    color: #666;
    font-size: 14px;
  }
  
  .image-group {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    body {
      padding: 15px;
    }
    
    .container {
      padding: 20px;
    }
    
    h1 {
      font-size: 24px;
    }
    
    h2 {
      font-size: 20px;
    }
    
    .cta-button {
      width: 180px;
      font-size: 16px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/adoutUs.vue